import { render, staticRenderFns } from "./OfferInput.vue?vue&type=template&id=2ed838a3&scoped=true"
import script from "./OfferInput.vue?vue&type=script&lang=js"
export * from "./OfferInput.vue?vue&type=script&lang=js"
import style0 from "./OfferInput.vue?vue&type=style&index=0&id=2ed838a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed838a3",
  null
  
)

export default component.exports